// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"f2-z","displaySixCardTiles":"g2-z"};